import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import APIS from '../../constant/EndPoint';
import { paymentValidationForm } from '../../utils/validationSchema';
import Button from '../Reusable/Button';
import usePostHook from '../../customHooks/usePostHook';
import { useParams } from 'react-router';
import ComboboxInput from '../Reusable/Form/ComboboxInput';
import { queryClient } from '../../root.component';

const MakePayment = (props: any) => {
  const { id } = useParams()
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`invoice-${id}`],
    navigateURL: "",
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    reset,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(paymentValidationForm),
  });

  const handleMakePayment = async (data: any) => {
    const url = `${APIS.MAKE_PAYMENT}`;
    let formData = {
      ...data,
      invoice: id,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 201) {
        props?.setMakePayment(false)
        reset()
        queryClient.refetchQueries()
      }

    } catch (err) {
      console.log(err);
    }
  }
  return (
    <section className="bg-white dark:bg-gray-900 mt-4">
      <div className="max-w-2xl mx-auto px-4">
        <form className="mb-6">
          <ComboboxInput
            url={APIS.PAYMENT_METHOD}
            props={{}}
            queryKey={"payment_method"}
            register={register("payment_method")}
            errors={errors?.payment_method}
            name={"payment_method"}
            label={"Payment Method"}
            setValue={setValue}
            placeholder={"Search Payment Method"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <div className="my-4 px-4 mb-4 bg-white rounded-lg rounded-t-lg border border-gray-200 dark:bg-gray-800 dark:border-gray-700">
            <label htmlFor="comment" className="sr-only">Your comment</label>
            <textarea id="comment" rows={6}
              {...register("note")}
              className="px-0 w-full text-sm text-gray-900 border-0 focus:ring-0 focus:outline-none dark:text-white dark:placeholder-gray-400 dark:bg-gray-800"
              placeholder="Write a comment..." required></textarea>
          </div>
          <div className="flex justify-end w-full">
            <div className="w-[150px]">
              <Button
                label={"Make Payment"}
                isLoading={isPostLoading}
                onClick={handleSubmit((data: any) =>
                  handleMakePayment(data)
                )}
              />
            </div>
          </div>
        </form></div>
    </section>
  )
}

export default MakePayment
